/**
 * The administrators' appearance (ADR-0053): a stylesheet after the app's own, unless the
 * address asks for the plain look (`?appearance=off`), the way back from CSS that breaks a screen.
 */
const ID = "paginae-appearance";

export function loadAppearance(version?: number) {
  if (new URLSearchParams(location.search).get("appearance") === "off") return;
  let link = document.getElementById(ID) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.id = ID;
    link.rel = "stylesheet";
    document.head.append(link);
  }
  link.href = `/api/appearance.css${version === undefined ? "" : `?v=${version}`}`;
}

/** After a change: the new stylesheet, at once. */
export const reloadAppearance = () => loadAppearance(Date.now());
